module.exports = __webpack_public_path__ + "img/text_4.5e9caf99.svg";